import { callEditorApi } from 'owa-editor/lib/utils/callApi';
import { EditorViewState } from 'owa-editor';

export const TOGGLE_DICTATION_SOURCE = '_ToggleDictationSource';

export default function toggleDictation(viewState: EditorViewState) {
    // TODO: Work Item 61334: [Remove findComposePlugins] DictationPlugin
    // This is a temp workaround. We trigger a ContentChanged event to make the lazy plugin imported,
    // and let it handle this event to toggle dictation.
    callEditorApi(viewState, 'triggerContentChangedEvent', TOGGLE_DICTATION_SOURCE);
}
